module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-5 p-mb-5"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "name"
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "relationship"
    }
  }, [_vm._v("Relationship")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "relationship"
    },
    model: {
      value: (_vm.relationship),
      callback: function($$v) {
        _vm.relationship = $$v
      },
      expression: "relationship"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "dob1"
    }
  }, [_vm._v("Date of Birth")]), _vm._v(" "), (!_vm.englishDateEnabled) ? _c('date-picker', {
    attrs: {
      "valueType": "format"
    },
    model: {
      value: (_vm.dateOfBirth),
      callback: function($$v) {
        _vm.dateOfBirth = $$v
      },
      expression: "dateOfBirth"
    }
  }) : _c('InputMask', {
    staticClass: "nepali-calendar form-control",
    attrs: {
      "mask": "9999-99-99",
      "type": "text",
      "id": "dob1"
    },
    model: {
      value: (_vm.dateOfBirth),
      callback: function($$v) {
        _vm.dateOfBirth = $$v
      },
      expression: "dateOfBirth"
    }
  })], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-5 p-mb-5"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-1"
  }, [_c('Button', {
    staticClass: "p-button-raised",
    attrs: {
      "label": "Save",
      "icon": "pi pi-save"
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8450ddbe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/HumanResource/Employee/dependents.vue
// module id = 2352
// module chunks = 0